// Base URLs
const REMOLONAS_API_BASE_URL = 'https://api.remolonas.com/api/v1/';
const ASSETS_BASE_URL = 'https://www.remolonas.com/cdn/shop/t/15/assets/';

// URLs for specific pages
const TIMESLOT_SELECTION_PAGE = '/pages/franjas-horarias';

// Shipping costs
const SHIPPING_COSTS = 4.5;
const FREE_SHIPPING_THRESHOLD = 19.0;

/**
 * Abort all active abortControllers to prevent network errors when navigating away from the page.
 */
const abortControllers = [];

window.addEventListener('beforeunload', () => {
    abortControllers.forEach(controller => controller.abort());
});